import { Component, inject, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { OrderState } from "../../enums/order-state.enum";
import { Order } from "../../models/order.model";
import { RolesEnum } from "../../enums/roles.enum";
import { AuthService } from "../../services/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { WebOrderService } from "../../services/web-order.service";
import { WebOrderModel } from "../../models/web-order.model";

@Component({
    selector: 'app-order-information',
    templateUrl: './order-information.component.html',
    styleUrls: ['./order-information.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OrderInformationComponent implements OnInit {
  @Input() order: Order;
  public dialogData = inject(MAT_DIALOG_DATA, { optional: true });
  public dialogRef = inject(MatDialogRef<OrderInformationComponent>, { optional: true });
  protected readonly OrderState = OrderState;
  protected readonly RolesEnum = RolesEnum;
  public authService = inject(AuthService);
  public translate = inject(TranslateService);
  public webOrderService = inject(WebOrderService);
  webOrder: WebOrderModel | null = null;
  public editMode = false;

  ngOnInit(): void {
    if (this.dialogData && this.dialogData.order) {
      this.order = this.dialogData.order;
    }
    if (this.order && this.order.webOrderId) {
      this.getWebOrder(this.order.webOrderId).then();
    }
  }

  /**
   * Get the list of contacts as string separated by a comma
   * @returns The list of contacts
   */
  public getContacts(): string {
    if (!this.order.customerEmails.length) {
      return '--';
    }
    return this.order.customerEmails.join(', ');
  }

  async getWebOrder(webOrderId: string): Promise<void> {
    try {
      this.webOrder = await this.webOrderService.get(webOrderId);
    } catch (e) {
      // User might not have permission to access web-orders (e.g. external subcontractor)
    }
  }
}
